module.exports = __webpack_public_path__ + "img/logo-cxx.4b04817e.png";